export default __webpack_public_path__ + "static/media/add.6b585049.svg";